// Utility Functions
// Barrel exports for all SOW utilities.

// Currency formatting
export {
  formatCurrency,
  parseCurrency,
  formatPercentage,
  isValidCurrencyInput,
} from './currency';

// Calculations
export {
  sumFieldValues,
  calculateCategorySubtotal,
  calculateSubtotal,
  calculateContingency,
  createContingencyData,
  calculateTotal,
  recalculateTotals,
  categoryHasValues,
  countNonZeroFields,
  calculateFillPercentage,
  hasNonZeroValues,
  countNonZeroValuesInFields,
} from './calculations';

// Data operations
export {
  initializeSOWData,
  mergeWithDefaults,
  setUnitCount,
  switchPropertyType,
  updateFieldValue,
  updateDescription,
  updateContingencyMode,
  updateContingencyValue,
} from './data';

// Filtering
export {
  filterSOWData,
} from './filtering';

// Serialization
export {
  SCHEMA_VERSION,
  serializeSOWData,
  serializeToObject,
  deserializeSOWData,
  deserializeFromObject,
  validateSOWData,
  normalizeSOWData,
} from './serialization.core';

export type {
  SerializedSOWData,
  ValidationResult,
} from './serialization.core';

// PDF Generation
export {
  generateReportHTML,
  generateFlatHTML,
} from './pdf.core';

export type {
  PDFGeneratorOptions,
} from './pdf.core';
